module.exports = __webpack_public_path__ + "static/media/f2_image@2x.e34b4eb7.png";